import { GetTianMuChildDeviceList } from '@/axios/IDevice.js'

const tianmuMixins = {
  data () {
    return {
      TianmuIsShow: false,
      isEditVideoScene: false, //天幕场景是否开启编辑
      TianmuVideoSceneNo: 0, //场景-选择天幕场景
      selectedSceneNo: 0, // 设备-选择天幕场景
      iftttPlantId: '', // 选择设备天幕的PlantId
    }
  },

  methods: {
    async handleTianMuInIfttt({ActionList, VDeviceId}){
      //指定视频播放
      const found = (ActionList || []).find(item => item.MsgType === "0x14350000");
      if(!found) return
      if(!VDeviceId) return
      const {Result,StatusCode } = await GetTianMuChildDeviceList({ VDeviceId })
      if (StatusCode == this.$store.state.rightStatusCode) {
        const { PlanId } = Result
        return PlanId
      }
    },

    handleTianmuClose(){
      this.TianmuIsShow = false
      this.$store.commit('setIsSupportPreview', false)
    },

     setSceneVideoDevice(device){
      this.addDevicesTemp = []
      this.addDevicesTemp.push(device)
      this.temdevice = device
      this.doFindActionAbility()
    },
    sceneVideoConfirm(action){
      this.$store.commit('setIsSupportPreview', false)
      this.okaction()
      this.TianmuIsShow = false
      this.actionlist = action
      console.log("🚀 ~ sceneVideoConfirm ~ action:", action)
    },

    showTianmuVideo(scene) {
      // 打开弹窗
      this.TianmuVideoSceneNo = scene.SceneNo
      this.$store.commit('setIsSupportPreview', true)
      this.TianmuIsShow = true
    },

    //如果天幕没有选择视频场景，给个提示
    checkTianmuSceneNo(_tempaction) {
      for (const item of _tempaction) {
        const Values = item?.Values
        if (!Values) continue

        for (const tem of Values) {
          if (tem.ValueType === 'UIControl_TianMu_Video_Group' && tem.DefaultValue === 0) {
            return false  // 发现未选择场景，直接返回
          }
        }
      }
      return true
    },

    //针对天幕视频，点击编辑，选择不同的场景，回显到自动化详情界面场景
    //模版自动化不用加，因为模版自动化不允许编辑
    setActionDefaultValue(){
      this.actionlist.forEach(actionItem => {
        actionItem.ischeck = true
        const Values = actionItem.Values
        Values.forEach(tem => {
          if(tem.IsShow && tem.ValueType === 'UIControl_TianMu_Video_Group'){
             this.selectedSceneNo = tem.DefaultValue
          }
        });
      });
    },

  }
};


export default tianmuMixins;